<template lang="pug">
	div(id="chartContainer" )
		div(class="chart-header") {{p_tableName}}
		hr
		div(class="d-flex")
			b-form-radio-group(class="radioGroup" label="Chart" v-model="d_chartType" size="sm")
				b-form-radio(v-if="/^(oppr|proj)$/.test(p_appEntKey)" v-model="d_chartType"  value="Gantt") Gantt
				b-form-radio(v-model="d_chartType"  value="Bar") Bar
				b-form-radio(v-model="d_chartType"  value="Pie") Pie
			div(v-if="/^(Bar|Pie)$/.test(d_chartType)" class="d-flex")
				label X:  
				b-form-select(id="xColumn" :options="c_xColumns"  tag-variant="primary" v-model="d_xColumn" style="font-size: 0.8rem;width:30%" placeholder="" @change="m_xColumnChange($event)")
				label Y:
				b-form-select(:options="c_yColumns" id="yColumn" tag-variant="primary" v-model="d_yColumn" style="font-size: 0.8rem;width:30%;" placeholder="" @change="m_yColumnChange($event)")
				b-form-radio-group(class="radioGroup" v-model="d_aggregation" style="font-size:0.8rem;" @change="m_aggregationChange($event)")
				b-form-radio(v-model="d_aggregation"  value="Sum" :disabled="!d_yColumn") Sum
				b-form-radio(v-model="d_aggregation"  value="Average" :disabled="!d_yColumn") Average
				b-form-radio(v-model="d_aggregation"  value="Count") Count
			div(v-if="/^(oppr|proj)$/.test(p_appEntKey) && d_chartType=='Gantt'" class="d-flex")
				label From:
				b-input(type="date" style="width:120px;border:none;" v-model="c_startDate" @change="m_startDateChange" )
				label To:
				b-input(type="date" style="width:120px;border:none;" v-model="c_endDate" @change="m_endDateChange" )
				div( style="display:flex;margin-left:20px;")
					input(type="checkbox" id="opportunityCheckBox" v-model="d_opprCheckBox") 
					<span>Opportunities</span> 
					input(type="checkbox" id="projectCheckBox" v-model="d_projCheckBox" style="margin-left:20px;") 
					<span>Projects</span> 
				
		hr
		<div v-show="!d_noData && /^(Bar|Pie)$/.test(d_chartType)" id="myChartDiv" style="width:900px;">
			canvas(key="d_chartKey"  id="myBarPieChart" style="width:700px;height:550px;" )
		</div>	
		<div v-show="!d_noData && d_chartType=='Gantt'" id="ganttDiv" style="min-width:900px;max-width:1200px;">
			kt-gantt-chart(:p_startDate="d_startDate" :p_endDate="d_endDate" :p_constructionDates="c_ganttData" :p_opportunities="d_opprCheckBox" :p_projects="d_projCheckBox" )
		</div>
		<div v-show="d_noData" id="no-data">No Data</div>		
</template>
<script>
import  util,{kbdpAlert} from "@/utils/util.js";
import {fn_appEnt} from "@/utils/ref-data.js";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-plugin-labels";
import KTGanttChart from "@/components/Ctrl/KT-GanttChart.vue";
import {fn_getConstructionDates} from "@/utils/api.js";
import moment from "moment";
export default {
	name: "kt-barpiechart",
	components: {'kt-gantt-chart':KTGanttChart},
	created() {
	
			
		this.d_appEnt = fn_appEnt(this.p_appEntKey);
		//var today=new Date();
		//this.d_today=today.toISOString().slice(0,10)+" 00:00:00";
		//if(!this.d_startDate) this.d_startDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0,10)+" 00:00:00";
		//var startDate=new Date(today.getFullYear(), today.getMonth(), 1);
		//if(!this.d_endDate) this.d_endDate = new Date(startDate.setMonth(startDate.getMonth() + 12)).toISOString().slice(0,10)+" 00:00:00";	
		
		
		
		const today = new Date();
		this.d_today = today; // keep as Date object

		if (!this.d_startDate) {
				this.d_startDate = new Date(today.getFullYear(), today.getMonth(), 1);
			}

		const startDate = new Date(today.getFullYear(), today.getMonth(), 1);

		if (!this.d_endDate) {
			this.d_endDate = new Date(startDate.setMonth(startDate.getMonth() + 12));
			}

		this.m_getContructionDates();


		
		},
	mounted(){
			var d_localChartData = JSON.parse(localStorage.getItem('localChartData'+this.p_tableName));
			console.log("In kt-barpiechart mounted"); 
			console.log(d_localChartData);
			if(d_localChartData){
						this.d_xColumn=d_localChartData.xColumn;
						this.d_yColumn=d_localChartData.yColumn;
						this.d_aggregation=d_localChartData.aggregation;
						this.d_chartType=d_localChartData.chartType;


			var chartImage=this.m_getChartImage({title:this.d_chartTitle,data:this.p_tableData,breakColumn:this.d_xColumn,
					chartType:this.d_chartType,chartColumn:this.d_yColumn});
						
		}
	},
	data() {
		return {

			d_appEnt: null,

			d_chartOptions:[{html:'<b style="color:blue;">Pie</b>',value:'Pie' },{html:'<b style="color:green;">Bar</b>', value:'Bar' }],
			d_chartType:'Gantt',
			d_xColumn:null,
			d_yColumn:null,
			d_myChart:null,
			d_chartImage:null,
			d_chartKey:0,
			d_aggregation:"Count",
			d_chartTitle:null,
			d_aggregators:[{name:"Sum",aggreFn:(values)=>{return values.reduce((sum,currentValue)=>
																		sum+(currentValue||0),0);}},
						{name:"Average",aggreFn:(values)=>{return values.reduce((sum,currentValue)=>
																		sum+(currentValue||0),0)/values.filter(v=>v).length;}},
						{name:"Count",aggreFn:(values)=>{return values.length;}}
						],
			d_chartDefaults:[{tableName:"Opportunities",xColumn:"opportunityStatusId",yColumn:"value",aggregation:"Sum"},
							{tableName:"Projects",xColumn:"projectStatusId",yColumn:"value",aggregation:"Sum"},
							{tableName:"Accounts",xColumn:"createdById",yColumn:"",aggregation:"Count"},
							{tableName:"Contacts",xColumn:"createdById",yColumn:"",aggregation:"Count"},
							{tableName:"Competitors",xColumn:"createdById",yColumn:"",aggregation:"Count"},
							{tableName:"Team Members",xColumn:"teamMemberName",yColumn:"",aggregation:"Count"},
							{tableName:"Activities",xColumn:"taskStatusId",yColumn:"status",aggregation:"Count"}
							],
			d_noData:false,
			d_ChartX:null,
			d_chartY:null,
			d_xLimitCheckBox:null,
			d_xCountLimit:null,
			d_xPercentageCheckBox:null,
			d_xPercentageLimit:0,
			d_startDate:null,
			d_endDate:null,
			d_today:null,
			d_opprCheckBox:true,
			d_projCheckBox:true,
			d_constructionDates:[],
			
			

		};
	},
	props: {
		p_appEntKey: String,
		p_tableName:String,
		p_cols:Array,
		p_tableData:Object,
	},
	computed: {
			c_xColumns(){ return [...this.p_cols.map(c=>c.title)];},
			c_yColumns(){ return [...this.p_cols.filter(c =>(c.datatype=="num"||c.datatype=="number"||c.datatype=="money")).map(c=>c.title)];},
			c_chartColumns(){ return [...this.p_cols.filter(c =>(c.datatype=="num"||c.datatype=="number"||c.datatype=="money")).map(c=>c.title)];},
			c_appEntName(){ return this.p_tableName.includes('Activities')?this.p_tableName:this.d_appEnt.label;},
			c_chartMinWidth(){return '900px;';},
			c_startDate() {return this.d_startDate?moment(this.d_startDate).format('YYYY-MM-DD'):null;},
			c_endDate() {return this.d_endDate?moment(this.d_endDate).format('YYYY-MM-DD'):null;},
			c_ganttData() {
			
			 return this.d_constructionDates.filter(c => {
				const s = new Date(c.startDate);
				const e = new Date(c.endDate);

				// Exclude null, undefined, or invalid dates
				if (isNaN(s) || isNaN(e)) return false;

				// Apply your range filter
				//return s >= this.d_startDate && e <= this.d_endDate;
				return e >= this.d_startDate && s <= this.d_endDate;

				});
				
				//return ganttData;
			},
			
},
methods: {
	m_startDateChange(e) {
    this.d_startDate = new Date(e); // ensure it's a Date object

    const end = new Date(e);        // clone, don't mutate
    end.setMonth(end.getMonth() + 12);

    this.d_endDate = end;           // keep as Date object
	},
    m_endDateChange(e) {
      this.d_endDate=new Date(e);
	  var months=this.m_getMonthDiff(this.d_startDate ,this.d_endDate); 
    },
	m_closeChildWindow(){document.getElementById("d_reportTitle").focus();},
	m_chartTypeChange(e){
		if(e=='Gantt') return;
		
		console.log(`In m_chartTypeChange ${e}`);
		var chartType=e;
		var xColumn=this.p_cols.filter(c =>c.title==this.d_xColumn)[0]?.field	
		var yColumn=this.p_cols.filter(c =>c.title==this.d_yColumn)[0]?.field
		if(chartType&&xColumn)
			console.log(`In m_chartTypeChange2 ${e}`);
			var chartImage=this.m_getChartImage({title:this.d_chartTitle,data:this.p_tableData,breakColumn:xColumn,chartType:chartType,chartColumn:yColumn});
		},
	m_xColumnChange(e){
	
	console.log(`In m_xColumnChange${e}`);
							
	var xColumn=this.p_cols.filter(c =>c.title==e)[0]?.field
	//var xColumn=this.p_cols.filter(c =>c.title==this.d_xColumn)[0]?.field
	var yColumn=this.p_cols.filter(c =>c.title==this.d_yColumn)[0]?.field
	this.d_chartTitle=this.p_tableName+' By '+e;

	
	if(this.d_chartType&&xColumn)
		console.log(`d_chartType:${this.d_chartType} xColumn:${xColumn} yColumn:${yColumn}`);
		var chartImage=this.m_getChartImage({title:this.d_chartTitle,data:this.p_tableData,breakColumn:xColumn,chartType:this.d_chartType,chartColumn:yColumn});
	},
	m_yColumnChange(e){
	
	var xColumn=this.p_cols.filter(c =>c.title==this.d_xColumn)[0]?.field	
	var yColumn=this.p_cols.filter(c =>c.title==e)[0]?.field
	//var yColumn=this.p_cols.filter(c =>c.title==this.d_yColumn)[0]?.field
	
	if(this.d_chartType&&xColumn)
		var chartImage=this.m_getChartImage({title:this.d_chartTitle,data:this.p_tableData,breakColumn:xColumn,chartType:this.d_chartType,chartColumn:yColumn});
	},
	m_aggregationChange(e){
	
		this.d_aggregation=e;
		var xColumn=this.p_cols.filter(c =>c.title==this.d_xColumn)[0]?.field	
		var yColumn=this.p_cols.filter(c =>c.title==this.d_yColumn)[0]?.field
			if(this.d_chartType&&xColumn)
					var chartImage=this.m_getChartImage({title:this.d_chartTitle,data:this.p_tableData,breakColumn:xColumn,chartType:this.d_chartType,chartColumn:yColumn});
		},
	m_getChartImage(chartData){
	
	var {title,data,breakColumn,chartType,chartColumn}=chartData;

	var chartX=[];
	var chartY=[];
	
		/* get  Unique break values */
		var breakValues=[];
		data.filter(d=>d[breakColumn]).forEach(rec =>{
			if(!breakValues.includes(rec[breakColumn])) breakValues.push(rec[breakColumn]);
			});
		
		var aggreFn=this.d_aggregators.filter(a=>a.name==this.d_aggregation)[0].aggreFn;
		
		breakValues.forEach(r=>{
							var breakRecords=data.filter(rec=>rec[breakColumn]==r).map(b=>{return b[chartColumn];});
							var valFmtFn=this.p_cols.filter(c=>c.field==breakColumn)[0].valFmtFn;
	
							chartX.push(valFmtFn?valFmtFn(r):r);
							chartY.push(aggreFn(breakRecords));	
							});
							
	var d_localChartData={  xColumn:this.d_xColumn,
							yColumn:this.d_yColumn,
							aggregation:this.d_aggregation,
							chartType:this.d_chartType,
						};
	localStorage.setItem('localChartData'+this.p_tableName, JSON.stringify(d_localChartData));
	
	this.d_ChartX=[...chartX];
	this.d_ChartY=[...chartY];
	
	//const canvasDiv = document.getElementById("myChartDiv");
	//canvasDiv.width = 1275; //chartX.length*50; 
	//canvasDiv.height = 637;   //350+(chartX.length-15)*50; 
	
	var vChartX=[...chartX];
	var filteredChartX=[];
	var filteredChartY=[];
	var idx;
	var max;
	if(this.d_xCountLimit){
		for (let i = 0; i < this.d_xCountLimit; i++) {
			max = Math.max(...vchartY);
			filtereChartY.push(max);
			idx=chartY.indexOf(max);
			filteredChartX.push(chartX[idx]);
			vchartY= vchartY.filter(num => num !== max);
			}
		this.d_ChartX=[...filteredchartX];
		this.d_ChartY=[...filteredchartY];	
		}
		

	
	if(this.d_xPercentageLimit) {
		var filteredChartX=[];
		var filteredChartY=[];	
		const total = this.d_ChartY.reduce((acc, value) => acc + value, 0);
		this.d_ChartY.forEach((value, index) => {
		const percentage = (value / total) * 100;
			if (percentage >= this.d_xPercentageLimit) {
				filteredData.push(value);
				filteredLabels.push(originalLabels[index]);
			}
		});
		this.d_ChartX=[...filteredchartX];
		this.d_ChartY=[...filteredchartY];
		}
		
	
	return this.m_generateChart(title,chartX,chartY,chartType,chartColumn);
					
	},
	m_generateChart(title,chartX,chartY,chartType,chartColumn){
	
	
	this.d_noData=false;
	if(this.d_myChart) this.d_myChart.destroy();	
	var ctx=document.getElementById('myBarPieChart').getContext('2d');
	
	//var valFmtFn=null;
	//if(this.pcols&&this.d_aggregation !== 'Count')
	var valFmtFn=this.p_cols.filter(c=>c.field==chartColumn)[0].valFmtFn;
	var column=this.p_cols.filter(c=>c.field==chartColumn)[0];
		
	console.log(this.p_cols);
	console.log(this.p_cols.filter(c=>c.field==chartColumn));
	
	if(!ctx){return;}
	
	var _this=this;
	this.d_myChart = new Chart(ctx, {
    type: chartType.toLowerCase(),
	responsive: true,
    maintainAspectRatio: false,
	plugins: [ChartDataLabels],	
    data: {
        labels: [...chartX],
        datasets: [{
            label: title,
            data: [...chartY],
            backgroundColor: [...this.m_getRandomColors(chartX.length)],
            borderColor: [...this.m_getRandomColors(chartX.length)],
            borderWidth: 1,
			valFmtFn:valFmtFn,
			column:column,
			aggregation:this.d_aggregation
			
        }]
    },
    options: {
		animation: {
			onComplete: function(animation) {
			var firstSet = animation.chart.config.data.datasets[0].data;
			console.log('datasets');
			console.log(animation.chart.config.data.datasets);
			if (!firstSet.length) _this.d_noData=true; 
			}
		},
		plugins: {
		

			labels: [
					{
					render: (context) => {return `${context.label} ${context.percentage}%`;},
					showZero: false,
					fontSize: 10,
					position: 'outside',
					textMargin: 5,
					}
				],
					
			datalabels: {
				formatter: (value, ctx) => {
					console.log('In formatter');
					console.log(ctx);
					if (ctx.dataset.valFmtFn && ctx.dataset.aggregation !== 'Count') {
						return ctx.dataset.valFmtFn(value);
						}
				      return value;
				}
			}
		
				
					
					
	},
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
					}
				}]
			}, 

	}
	
	});
	
	var chartImg=document.getElementById('myChart');
	if(chartImg) return chartImg.toDataURL('image/jpeg',1.0); else return null;
	
	},
	m_getColors(n){
	var colors=['#33adff','#2d8bba','#2f5f98','#31356e','#4076ba','#41b8d5','#6ce5e8','#004f98',
				'#4682b4','#5072a7','#b0c4de','#6082b6','#417dc1','#483d8b','#99badd','#ff5500',
				'#00bfff','#126180','#5b92e5','#a2add0','#a2a2d0','#92a1cf','#778ba5','#1f75fe',
				'#ff002a'];
				
	for(let i = colors.length; i < n; i++){
		var r=Math.floor(Math.random()*255);
		var g=Math.floor(Math.random()*255);
		var b=Math.floor(Math.random()*255);
		colors.push(`rgba(${r},${g},${b},0.5)`);
	}	 
	return colors;	 
	},
	m_getRandomColors(n){
	var color;
	var colors=['#33adff','#ffd500','#ff5500','#ff002a','#2d8bba','#2f5f98','#31356e','#4076ba','#41b8d5','#6ce5e8','#004f98',
				'#4682b4','#5072a7','#b0c4de','#6082b6','#417dc1','#483d8b','#99badd',
				'#00bfff','#126180','#5b92e5','#a2add0','#a2a2d0','#92a1cf','#778ba5','#1f75fe'];
				
	//var letters='0123456789ABCDEF'.split('');
	var letters = [0,1,2,3,4,5,6,7,8,9,'A','B','C','D','F']
	for(let i = colors.length; i < n; i++){
			color='#';
			for(let k = 0; k < 6; k++){
				color+=letters[Math.floor(Math.random()*16)];
		}
		colors.push(color);
	} 
	return colors;	 
},
m_fullScreenClick(){
		var chartContainer = document.getElementById("gantt-chart");
		chartContainer.requestFullscreen({ navigationUI: "hide" }).then(() => {}).catch(err => {
		alert(`An error occurred while trying to switch into full-screen mode: ${err.message} (${err.name})`);
		});
  },
m_getMonthDiff(date1, date2) {
      return (
        (date1.getFullYear() - date2.getFullYear()) * 12 +
        (date1.getMonth() - date2.getMonth())
      );
	},
m_getContructionDates(){
	
		fn_getConstructionDates().then(resp => {
			
		this.d_constructionDates = [ ...resp.constructionDates];
			
		console.log("In fn_getConstructionDates");
		console.log(this.d_constructionDates);
	
        });
	
	},
},
watch:{
p_tableData(nv,ov){ 
	if( nv && nv.length>0 && /^(Bar|Pie)$/.test(this.d_chartType)){

		//var chartType="Bar";
		var chartType=this.d_chartType;
		var xColumn;
		var yColumn;
		var tableName=this.p_tableName.includes('Activities')?'Activities':this.p_tableName;
		this.d_chartTitle=this.d_chartTitle=this.p_tableName+' By '+this.d_xColumn;
		if(this.d_xColumn) xColumn=this.p_cols.filter(c =>c.title==this.d_xColumn)[0]?.field;
		else {
			xColumn=this.d_chartDefaults.filter(c =>c.tableName==tableName)[0]?.xColumn;
			this.d_xColumn=this.p_cols.filter(c=>c.field==xColumn)[0]?.title;
			}
		if(this.d_yColumn) yColumn=this.p_cols.filter(c =>c.title==this.d_yColumn)[0]?.field;	
		else {  yColumn=this.d_chartDefaults.filter(c =>c.tableName==tableName)[0]?.yColumn;
				this.d_yColumn=this.p_cols.filter(c=>c.field==yColumn)[0]?.title;
			}
		
		if(!this.d_aggregation) this.d_aggregation=this.d_chartDefaults.filter(c =>c.tableName==tableName)[0]?.aggregation;
		if(chartType&&xColumn)
			var chartImage=this.m_getChartImage({title:this.d_chartTitle,data:this.p_tableData,breakColumn:xColumn,chartType:chartType,chartColumn:yColumn});
	}
  },
  d_chartType(nv){this.m_chartTypeChange(nv);},
  d_aggregation(nv){this.m_aggregationChange(nv);},
 }  
};
</script>

<style  scoped lang="less">
div.kt-chart-opts {
	//width: 240px;
	div.chart-header {
		padding: 0.2em 0.4em;
		background-color: #6c757d;
		color: #fff;
		margin-bottom: 0.0em;
	}
}
#chartContainer {
	border: none;
	border-radius: 6px;
	overflow: hidden;
	background: #fff;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}
.btn-link {
	display:inline-block;
	//width: 100%;
	padding-bottom: 0.5em;
	text-align: left;
	}
.btn-100{
     width: 100%;
    }
.moneycolor{color:blue;}
.textleft{	text-align: left;}
.fw-bold{font-weight: bold;}
.ta-end{text-align: end;}
.ta-start{text-align: start;}
.selectinput {
			width:100%;
			margin-right: 0.3em;
			opacity: 0.5;
			border:none;
			color:#007bff;
			&:hover {
			opacity: unset;
				}
			}
.selectinput{
  content: "↓";
  display: flex;
  flex: 1;
  align-items: center;
  padding: 0;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  border-width: 1px;
  border-style: inherit;
  border-color: inherit;
  border-radius: inherit;
}
.selectinput:hover::after {
  background-color: #007bff;
}
.optioninput{
			border:none;
			color:#007bff;
		}
.modalPage{ width: 200px;
			float:right;
			}
div.form-group {
		min-width: 300px;
		//display: flex;
		flex-wrap: wrap;
		> label {
			min-width: 130px;
			margin: auto 0;
		}
     }
.input-value {
			margin-right: 0.8em;
			opacity: 0.5;
			&:hover {
			opacity: unset;
				}
			}
.reportLabel{margin-right: 0.2em;}
.reportLabel2{margin-left: 1.0em;}
.btn {margin-right: 0.3em;}
.line{border:none;
   margin-top:0.1em;
   margine-bottom:0.1em;
}
.addEditReportMain{
		height:600px;
}
.col-toggle {
	ul.dropdown-menu {
		padding: 0.5em 0;
		max-height: 350px;
		min-width: 150px;
		overflow-y: auto;
        scrollbar-width:thin;
		}
	}
.dropdown-item {
				padding: 0.2em 0.75em;
				display: flex;
				}
.btn-reorder-columns {
	cursor: move;
	padding: 0;
}
.sort-by{
					&.asc::after {
						content: " ↑";
						color: #4fa4ff;
					}
					&.desc::after {
						content: " ↓";
						color: #4fa4ff;
					}
}
.btn-sort{
		margin-left:0.1em;
		width:0.8em;
		height:0.8em;
	}
.btn-total{
		margin-left:0.1em;
		width:0.8em;
		height:0.8em;
		}
.btn-break{
		margin-left:0.1em;
		width:0.8em;
		height:0.8em;
		}
svg.fa-check {
				font-size: 0.8em;
				color: #28a745;   //#dc3545;
				&:hover {
					opacity: 0.8;
						}
	}
.modalDiv{max-width:700px;}	
.btn-menu{border:none;}
a.disabled {
	color:grey;
	pointer-events: none;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒"; 
  color: #1E90FF; 
  /* you can style it however you want, use background-image for example */
}

/* By using [open] we can define different styles when the disclosure widget is open */
details[open] summary::before { 
  content:"🠣";  /*"🡑"*/ 
  color: #1E90FF; 
}
.sticky-header{
	position: -webkit-sticky;
	position: sticky;
	top: 0px;
	left: 0;
	background-color:white;
	z-index: 2;
		}
.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 0rem 1rem 1rem 1rem; 
}
div.chart-header {
		padding: 0.2em 0.4em;
		background-color: #6c757d;
		color: #fff;
		margin-bottom: 0.0em;
		border: none;
	}
.radioGroup{
			width:25%;
			border: none;
			margin-right:0.3rem
}
#opportunityCheckBox[type="checkbox"]:checked {
   accent-color: #9dc254;
}
#projectCheckBox[type="checkbox"]:checked {
   accent-color:#4076ba;
}


</style>